import { AxiosRequestConfig } from 'axios';
import {
  alphaInstance,
  baseInstance,
  nodeInstance,
  nodedevInstance,
  phoneValidationInstance,
  ticketmanInstance,
  alphaLoginInstance,
  alphaOrderInstance,
  nodeManchantInstance,
  agilityInstance,
} from '.';
import { Datum } from '../interfaces';
import { API_KEYS, API_LIBRARY as IAPI_LIBRARY } from '../interfaces/api';

export const API_LIBRARY: IAPI_LIBRARY = {
  GET_PRICE_QUOTE: {
    instance: baseInstance,
    request: {
      url: 'portal/getpricequote',
      method: 'post',
    },
  },
  GET_CATEGORIES_BY_COUNTRY: {
    instance: baseInstance,
    request: {
      url: 'portal/getcategoriesbycountry/:destinationCountryId/:departureCountryId',
      method: 'get',
    },
  },
  LOGIN: {
    instance: baseInstance,
    request: {
      url: 'portal/login',
      method: 'post',
    },
  },
  SIGN_UP: {
    instance: baseInstance,
    request: {
      url: 'portal/signup',
      method: 'post',
    },
  },
  EDIT_PROFILE: {
    instance: baseInstance,
    request: {
      url: 'portal/editprofile',
      method: 'post',
    },
  },
  FORGOT_PASSWORD: {
    instance: baseInstance,
    request: {
      url: 'portal/forgotpassword',
      method: 'post',
    },
  },
  CHANGE_PASSWORD: {
    instance: baseInstance,
    request: {
      url: 'portal/changepassword/:UserId/:currentPassword/:newPassword',
      method: 'put',
    },
  },
  GET_WALLET_BALANCE: {
    instance: baseInstance,
    request: {
      url: 'portal/getWalletBalance',
      method: 'get',
    },
  },
  GET_STATIONS: {
    instance: baseInstance,
    request: {
      url: 'portal/getStations',
      method: 'get',
    },
  },
  GET_ITEM_TYPES: {
    instance: baseInstance,
    request: {
      url: 'portal/itemTypes',
      method: 'get',
    },
  },
  GET_ACTIVE_LGAS: {
    instance: baseInstance,
    request: {
      url: 'portal/getactivelgas',
      method: 'get',
    },
  },
  GET_SPECIAL_PACKAGES: {
    instance: baseInstance,
    request: {
      url: 'portal/getspecialpackages',
      method: 'get',
    },
  },
  WALLET_TRANSACTIONS_SHIPMENT_HISTORY: {
    instance: baseInstance,
    request: {
      url: 'portal/getwallettransactionandpreshipmenthistory',
      method: 'post',
    },
  },
  TRACK_SHIPMENT: {
    instance: baseInstance,
    request: {
      url: 'portal/trackshipment/:waybillnumber',
      method: 'get',
    },
  },
  GET_HAULAGE: {
    instance: baseInstance,
    request: {
      url: 'portal/haulage',
      method: 'get',
    },
  },
  GET_HAULAGE_PRICE: {
    instance: baseInstance,
    request: {
      url: 'portal/gethaulagepriceformobile',
      method: 'post',
    },
  },
  GET_SHIPMENT_DETAILS: {
    instance: baseInstance,
    request: {
      url: 'portal/getpreshipmentmobiledetails/:waybillnumber',
      method: 'get',
    },
  },
  GET_SHIPMENT_IN_DISPUTE: {
    instance: baseInstance,
    request: {
      url: 'portal/getpreshipmentindispute',
      method: 'get',
    },
  },
  GET_DROPOFF: {
    instance: baseInstance,
    request: {
      url: 'portal/dropoffs/:waybillnumber',
      method: 'get',
    },
  },
  GET_OUTSTANDING_PAYMENTS: {
    instance: baseInstance,
    request: {
      url: 'portal/outstandingpayments',
      method: 'get',
    },
  },
  GET_PAYMENT_STATUS: {
    instance: baseInstance,
    request: {
      url: 'portal/paymentforshipment/:waybillnumber',
      method: 'get',
    },
  },
  GET_HOME_DELIVERY_LOCATIONS: {
    instance: baseInstance,
    request: {
      url: 'portal/activehomedeliverylocations',
      method: 'get',
    },
  },
  GET_STATIONS_BY_COUNTRY: {
    instance: baseInstance,
    request: {
      url: 'portal/getStationsByCountry/:countryid',
      method: 'get',
    },
  },
  GET_SERVICE_CENTERS_BY_STATION: {
    instance: baseInstance,
    request: {
      url: 'portal/servicecentresbystation/:stationid',
      method: 'get',
    },
  },
  GET_SERVICE_CENTERS_BY_COUNTRY: {
    instance: baseInstance,
    request: {
      url: 'portal/servicecentresbycountry/:countryid',
      method: 'get',
    },
  },
  GET_IDENTIFICATION_TYPES: {
    instance: baseInstance,
    request: {
      url: 'portal/identificationtypes',
      method: 'get',
    },
  },
  GET_ACTIVE_COUNTRIES: {
    instance: baseInstance,
    request: {
      url: 'portal/getactivecountries',
      method: 'get',
    },
  },
  GET_SHIPMENT_MESSAGE: {
    instance: baseInstance,
    request: {
      url: 'portal/intlshipmentsmessage',
      method: 'get',
    },
  },
  GET_NOTIFICATIONS: {
    instance: baseInstance,
    request: {
      url: 'portal/getnotifications',
      method: 'get',
    },
  },
  UPDATE_NOTIFICATION: {
    instance: baseInstance,
    request: {
      url: 'portal/updatenotification/:notificationid',
      method: 'put',
    },
  },
  GET_STORES_BY_COUNTRY: {
    instance: baseInstance,
    request: {
      url: 'portal/storesbycountry/:countryid',
      method: 'get',
    },
  },
  GET_INTERNATIONAL_SHIPMENTS: {
    instance: baseInstance,
    request: {
      url: 'portal/consolidatedintlshipments',
      method: 'get',
    },
  },
  VERIFY_PAYMENT: {
    instance: baseInstance,
    request: {
      url: 'portal/verifypayment/:waybillnumber',
      method: 'get',
    },
  },
  REPORT_ISSUES: {
    instance: baseInstance,
    request: {
      url: 'webtracking/reportIssues',
      method: 'post',
    },
  },
  GET_PRICE: {
    instance: baseInstance,
    request: {
      url: 'portal/getprice',
      method: 'post',
    },
  },
  GET_INTL_PRICE: {
    instance: baseInstance,
    request: {
      url: 'portal/getintlquickqoute',
      method: 'post',
    },
  },
  ADD_WAYBILL_PAYMENT_LOG: {
    instance: baseInstance,
    request: {
      url: 'portal/addwaybillpaymentlog',
      method: 'post',
    },
  },
  CREATE_SHIPMENT: {
    instance: baseInstance,
    request: {
      url: 'portal/createShipment',
      method: 'post',
    },
  },
  RESOLVE_DISPUTE: {
    instance: baseInstance,
    request: {
      url: 'portal/resolvedispute',
      method: 'post',
    },
  },
  CANCEL_SHIPMENT: {
    instance: baseInstance,
    request: {
      url: 'portal/cancelshipment/:waybillnumber',
      method: 'post',
    },
  },
  DELETE_SHIPMENT: {
    instance: nodeInstance,
    request: {
      url: 'shipment/:waybillnumber',
      method: 'delete',
    },
  },
  CANCEL_SHIPMENT_NOCHARGE: {
    instance: baseInstance,
    request: {
      url: 'portal/cancelshipmentwithnocharge',
      method: 'post',
    },
  },
  ADD_WALLET_PAYMENT_LOG: {
    instance: baseInstance,
    request: {
      url: 'portal/addwalletpaymentlog',
      method: 'post',
    },
  },
  ADD_RATING: {
    instance: baseInstance,
    request: {
      url: 'portal/addratings',
      method: 'post',
    },
  },
  VERIFY_OTP: {
    instance: baseInstance,
    request: {
      url: 'portal/verifyotp',
      method: 'post',
    },
  },
  RESEND_OTP: {
    instance: baseInstance,
    request: {
      url: 'portal/resendotp',
      method: 'post',
    },
  },
  GET_DROPOFF_PRICE: {
    instance: baseInstance,
    request: {
      url: 'portal/dropoffprice',
      method: 'post',
    },
  },
  CREATE_DROPOFF: {
    instance: baseInstance,
    request: {
      url: 'portal/createdropoff',
      method: 'post',
    },
  },
  CANCEL_DROPOFF: {
    instance: baseInstance,
    request: {
      url: 'portal/dropoffs/:tempcode',
      method: 'delete',
    },
  },
  INTL_SHIPMENT_REQUEST_LIST: {
    instance: baseInstance,
    request: {
      url: 'portal/intlshipmentrequests',
      method: 'post',
    },
  },
  GET_DROP_OFF_LIST: {
    instance: baseInstance,
    request: {
      url: 'portal/dropoffs',
      method: 'post',
    },
  },
  CREATE_INTL_SHIPMENT_REQUEST: {
    instance: baseInstance,
    request: {
      url: 'portal/AddIntlShipmentTransactions',
      method: 'post',
    },
  },
  EDIT_INTL_SHIPMENT_REQUEST: {
    instance: baseInstance,
    request: {
      url: 'portal/intlshipmentrequest/:requestnumber',
      method: 'put',
    },
  },
  GET_INTL_SHIPMENT_MESSAGE: {
    instance: baseInstance,
    request: {
      url: 'portal/intlshipmentsmessage',
      method: 'get',
    },
  },
  PROFILE_INTL_USER: {
    instance: baseInstance,
    request: {
      url: 'portal/profileinternationaluser',
      method: 'put',
    },
  },
  GET_VEHICLE_STATUS: {
    instance: nodeInstance,
    request: {
      url: 'vehicle',
      method: 'get',
    },
  },
  UPLOAD_IMAGE: {
    instance: nodeInstance,
    request: {
      url: 's3upload/image-upload',
      method: 'post',
    },
  },
  HANDLE_SHIPMENT: {
    instance: nodeInstance,
    request: {
      url: 'shipment',
      method: 'post',
    },
  },
  GET_PARTNER_DETAILS: {
    instance: nodeInstance,
    request: {
      url: 'shipment/:waybillnumber',
      method: 'get',
    },
  },

  GET_DELIVERY_MANIFEST: {
    instance: nodedevInstance,
    request: {
      url: 'autoDelivery/customerDelivery/:manifestcode/:waybillnumber',
      method: 'get',
    },
  },

  REQUEST_QUOTE: {
    instance: baseInstance,
    request: {
      url: '/api/webtracking/requestQuote/',
      method: 'post',
    },
  },
  VERIFY_USER_PIN: {
    instance: baseInstance,
    request: {
      url: 'portal/verifyuserpin',
      method: 'post',
    },
  },
  CHARGE_WALLET: {
    instance: baseInstance,
    request: {
      url: 'portal/chargewallet',
      method: 'put',
    },
  },

  TICKETMAN_ACCESSTOKEN: {
    instance: ticketmanInstance,
    request: {
      url: 'token',
      method: 'post',
    },
  },

  GET_BILLS_CATEGORY: {
    instance: ticketmanInstance,
    request: {
      url: 'api/quickteller/getcategory',
      method: 'get',
    },
  },
  GET_BILLERS_BY_CATEGORY: {
    instance: ticketmanInstance,
    request: {
      url: 'api/quickteller/GetBillersByCategory',
      method: 'get',
    },
  },
  GET_BILLER_PAYMENT_ITEMS: {
    instance: ticketmanInstance,
    request: {
      url: 'api/quickteller/GetBillerPaymentItems',
      method: 'get',
    },
  },
  CUSTOMER_VALIDATION: {
    instance: ticketmanInstance,
    request: {
      url: 'api/quickteller/CustomerValidation',
      method: 'post',
    },
  },
  GET_PAYMENT_REFERENCE: {
    instance: ticketmanInstance,
    request: {
      url: 'PaymentInfo/GenerateReference',
      method: 'post',
    },
  },
  SEND_PAY_ADVICE: {
    instance: ticketmanInstance,
    request: {
      url: 'api/quickteller/SendPayAdvice',
      method: 'post',
    },
  },
  VALIDATE_PHONENUMBER: {
    instance: phoneValidationInstance,
    request: {
      url: 'lookup',
      method: 'get',
    },
  },
  GET_WALLETPIN_STATUS: {
    instance: baseInstance,
    request: {
      url: 'portal/checkforuserpin',
      method: 'get',
    },
  },

  ADD_USER_PIN: {
    instance: baseInstance,
    request: {
      url: 'portal/addgiguserpin',
      method: 'post',
    },
  },
  CHANGE_USER_PIN: {
    instance: baseInstance,
    request: {
      url: 'portal/changeuserpin',
      method: 'put',
    },
  },

  RESET_WALLET_PIN: {
    instance: baseInstance,
    request: {
      url: 'portal/resetuserpin',
      method: 'put',
    },
  },
  WALLETPIN_VERIFY_OTP: {
    instance: baseInstance,
    request: {
      url: 'portal/verifyotp',
      method: 'post',
    },
  },
  VALIDATE_BILLS_PAYMENT: {
    instance: baseInstance,
    request: {
      url: 'portal/validatebillspayment',
      method: 'put',
    },
  },
  GET_OUTBOUND_COUNTRIES: {
    instance: baseInstance,
    request: {
      url: 'portal/allcountry',
      method: 'get',
    },
  },
  GET_INTERNATIONAL_SHIPMENTS_RATE: {
    instance: baseInstance,
    request: {
      url: 'portal/internationalshipmentrate',
      method: 'post',
    },
  },
  GET_COMPUTE_COUPON: {
    instance: baseInstance,
    request: {
      url: 'portal/getcomputecouponamount/:coup/:total',
      method: 'get',
    },
  },

  GET_PAYMENTMETHOD_BY_COUNTRY: {
    instance: baseInstance,
    request: {
      url: 'portal/getpaymentmethod/:countryid',
      method: 'get',
    },
  },

  CHECK_CELLULANT_ENCRYPTION: {
    instance: baseInstance,
    request: {
      url: 'portal/checkoutencryption',
      method: 'post',
    },
  },
  GET_CURRENCY_EQUIVALENT: {
    instance: baseInstance,
    request: {
      url: 'portal/currencyequivalent',
      method: 'post',
    },
  },

  GET_INTL_SHIPMENT_QUOTE: {
    instance: baseInstance,
    request: {
      url: 'portal/internationalshipmentquote',
      method: 'post',
    },
  },
  ALPHA_LOGIN: {
    instance: alphaLoginInstance,
    request: {
      url: 'auth/login',
      method: 'post',
    },
  },
  GET_ALPHA_PRODUCT: {
    instance: alphaInstance,
    request: {
      url: 'product/search',
      method: 'get',
    },
  },

  GET_ALPHA_STATIONS: {
    instance: alphaOrderInstance,
    request: {
      url: 'order/guest/stations',
      method: 'get',
    },
  },

  GET_ACTIVE_ALPHA_LOCATIONS: {
    instance: alphaInstance,
    request: {
      url: 'order/guest/getactive_location',
      method: 'get',
    },
  },

  GET_ALPHA_HOMEDELIVERY: {
    instance: alphaInstance,
    request: {
      url: 'order/guest/homedelivery_address',
      method: 'get',
    },
  },

  GET_ALPHA_PAYMENT_METHODS: {
    instance: alphaInstance,
    request: {
      url: 'gateway/list',
      method: 'get',
    },
  },

  GET_ALPHA_SERVICE_CENTERS: {
    instance: alphaInstance,
    request: {
      url: 'order/guest/service_centers/:stationId',
      method: 'get',
    },
  },
  GET_ALPHA_PRICE: {
    instance: alphaInstance,
    request: {
      url: 'order/guest/shipping_price',
      method: 'post',
    },
  },

  WITHDRAW_COD: {
    instance: baseInstance,
    request: {
      url: 'portal/stellaswithdrawal',
      method: 'post',
    },
  },
  VALIDATE_BANK: {
    instance: baseInstance,
    request: {
      url: 'portal/stellasvalidatebankname',
      method: 'post',
    },
  },
  GET_COD_BANKS: {
    instance: baseInstance,
    request: {
      url: 'portal/stellasbanks',
      method: 'get',
    },
  },
  GET_COD_HISTORY: {
    instance: baseInstance,
    request: {
      url: 'portal/allcodshipment',
      method: 'post',
    },
  },
  CHECK_USER_COD_EXIST: {
    instance: baseInstance,
    request: {
      url: 'portal/checkifuserhascodwallet/:userchannelcode',
      method: 'get',
    },
  },
  CREATE_STELLAS_ACCOUNT: {
    instance: baseInstance,
    request: {
      url: 'portal/createstellasaccount',
      method: 'post',
    },
  },
  VALIDATE_BVN: {
    instance: baseInstance,
    request: {
      url: 'portal/validatebvnnumber',
      method: 'post',
    },
  },
  CHECK_BVN_EXIST: {
    instance: nodeManchantInstance,
    request: {
      url: 'apimerchant/merchant/verifybvn/:bvn',
      method: 'get',
    },
  },
  GET_STELLAS_DETAILS: {
    instance: baseInstance,
    request: {
      url: 'portal/getstellalogindetails/:userchannelcode',
      method: 'get',
    },
  },
  GET_COD_ACCOUNT_STATEMENT: {
    instance: baseInstance,
    request: {
      url: 'portal/getcodcustomeraccountstatement',
      method: 'post',
    },
  },
  GET_PERSONAL_SHOPPING_LIST: {
    instance: baseInstance,
    request: {
      url: 'portal/getshopperitemsbyuserid',
      method: 'get',
    },
  },
  GET_PERSONAL_SHOPPING_RECEIVER: {
    instance: baseInstance,
    request: {
      url: 'portal/getreceiversbyuserid',
      method: 'get',
    },
  },
  GET_PERSONALSHOPPING_INVOICE: {
    instance: baseInstance,
    request: {
      url: 'portal/getinvoice',
      method: 'post',
    },
  },
  CREATE_PERSONAL_SHOPPING_ITEM: {
    instance: baseInstance,
    request: {
      url: 'portal/createshopperitem',
      method: 'post',
    },
  },
  UPDATE_PERSONAL_SHOPPING_ITEM: {
    instance: baseInstance,
    request: {
      url: 'portal/updateshopperitem/:id',
      method: 'patch',
    },
  },
  CHARGE_PERSONAL_SHOPPING_WALLET: {
    instance: baseInstance,
    request: {
      url: 'portal/chargewalletforshopperitems',
      method: 'put',
    },
  },
  DELETE_PERSONAL_SHOPPING_ITEM: {
    instance: baseInstance,
    request: {
      url: 'portal/deleteshopperitem/:id',
      method: 'delete',
    },
  },
  GENERATE_CHECKOUT_URL: {
    instance: baseInstance,
    request: {
      url: 'portal/generatecheckouturl',
      method: 'post',
    },
  },
  REGISTER_FOR_PROMO: {
    instance: agilityInstance,
    request: {
      url: 'portal/firsttimepromoinitiation',
      method: 'post',
    },
  },
};

const getApiUrlParams = (url: string): string[] => {
  const urlBits = url?.split('/');
  const params = urlBits?.filter((part) => part.startsWith(':'));
  return params;
};

const replaceParamsWithObject = (
  url: string,
  params: string[],
  urlParams: { [x: string]: string }
): string => {
  let apiUrl = url;
  params?.forEach((param) => {
    const paramName = param.substring(1);
    apiUrl = apiUrl?.replace(param, urlParams[paramName]);
  });
  return apiUrl;
};

export const makeRequest = async (
  token: string | null,
  api_key: API_KEYS,
  apiOptions?: Omit<AxiosRequestConfig, 'baseurl' | 'url' | 'method'>,
  urlParams?: Datum
) => {
  const api = API_LIBRARY[api_key];
  let apiUrl = api.request.url;

  if (!apiUrl) {
    throw new Error('Invalid API Url');
  }

  if (urlParams) {
    const params = getApiUrlParams(apiUrl);
    if (params.length) {
      apiUrl = replaceParamsWithObject(apiUrl, params, urlParams);
    }
  }

  if (getApiUrlParams(apiUrl).length) {
    throw new Error(`Provide values for ${getApiUrlParams(apiUrl).join(', ')}`);
  }

  const { headers, ...rest } = apiOptions || {};
  try {
    const response = await api.instance.request({
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        ...headers,
      },
      ...api.request,
      url: apiUrl,
      ...rest,
    });
    if (response?.data?.Code && response?.data?.Code !== '200') {
      return await Promise.reject(response);
    }
    return response;
  } catch (err: any) {
    return Promise.reject(err?.response || err);
  }
};
